var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import CheckboxField from "../../Form/CheckboxField";
import { ProgramMultiSearch } from "../Program/ProgramSearch";
import TextField from "../../Form/TextField";
import ProgramService from "../../../Services/Program.service";
export const SSE_FORM_PROGRAM_INTEREST_QUESTION_GET_CRITERIA = (formState) => {
    return formState;
};
export const SSE_FORM_PROGRAM_INTEREST_QUESTION_GET_FORM_STATE = (formField) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const getIfArrayHasItems = (arr, service) => {
        if (arr === null || arr === void 0 ? void 0 : arr.length) {
            return service(arr);
        }
        return Promise.resolve([]);
    };
    const [programs] = yield Promise.all([
        getIfArrayHasItems((_a = formField.criteria) === null || _a === void 0 ? void 0 : _a.programIds, (ids) => ProgramService.findAllById(ids)),
    ]);
    return Object.assign(Object.assign({}, formField), { criteria: Object.assign(Object.assign({}, formField.criteria), { programs }) });
});
const SSEFormProgramInterestQuestionForm = ({ makeName, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { maxLength: 60, name: makeName("fieldLabel"), label: "Question Label" }), _jsx(CheckboxField, { label: "Required", name: makeName("required") }), _jsx(CheckboxField, { label: "Only allow prospects to select one program", title: "Only allow prospects to select one program", name: makeName("criteria.limitSelectFieldToOne"), helpText: "Checking this box will allow prospects to select only one progam from the form. Leaving this box unchecked will allow up to 5 programs to be selected." }), _jsx(SearchField, { label: "Programs", name: makeName("criteria.programs"), as: (provided) => _jsx(ProgramMultiSearch, Object.assign({ lookupModal: true }, provided)), helpText: "Only selected programs on this field will be displayed on the form. By leaving this field empty, all current active programs in the system will be displayed." })] }));
};
export const ProgramInterestFormComponent = {
    form: SSEFormProgramInterestQuestionForm,
    getCriteria: SSE_FORM_PROGRAM_INTEREST_QUESTION_GET_CRITERIA,
    getFormState: SSE_FORM_PROGRAM_INTEREST_QUESTION_GET_FORM_STATE,
};
